import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import Button from '../global/Button';
import { addSelectedRosterIdentity } from '../../actions/discover-album-folder';
import WaldoSpeechBubble from '../global/WaldoSpeechBubble';
import OnboardingLayoutScrollableContent from '../../apps/temp/views/onboarding/OnboardingLayout/components/OnboardingLayoutScrollableContent';
import IdentityAvatarContainer from '../../containers/global/identity/IdentityAvatarContainer';

const propTypes = {
  albumFolderId: PropTypes.string,
};

const DiscoverAlbumFolderNoFrJoinChoose = ({ albumFolderId }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const foundRosterIdentities = useSelector(
    state => state.discoverAlbumFolder.foundRosterIdentities,
  );
  const selectedRosterIdentities = useSelector(
    state => state.discoverAlbumFolder.selectedRosterIdentities,
  );

  const selectedIds = selectedRosterIdentities.map(({ id }) => id);

  const onSelectRosterIdentity = rosterIdentity => {
    dispatch(addSelectedRosterIdentity(rosterIdentity));
    history.push(`/discover/album-folder/${albumFolderId}/no-fr-join/confirm`);
  };

  useEffect(() => {
    if (foundRosterIdentities?.length === 1) {
      const [rosterIdentity] = foundRosterIdentities;

      if (!selectedIds.includes(rosterIdentity.id)) {
        onSelectRosterIdentity(rosterIdentity);
      } else {
        history.push(
          `/discover/album-folder/${albumFolderId}/no-fr-join/confirm`,
        );
      }
    }
  }, [foundRosterIdentities]);

  if (!foundRosterIdentities || foundRosterIdentities.length === 0) {
    return (
      <Fragment>
        <div className="w-100">
          <Button
            btnSize="sm"
            btnStyle="link"
            onClick={() =>
              history.push(`/discover/album-folder/${albumFolderId}/no-fr-join`)
            }
          >
            &larr; Back
          </Button>
        </div>
        <WaldoSpeechBubble
          iconPath="/waldo-sad.svg"
          position="right"
          className="mb-4 w-100"
        >
          No matches were found.
        </WaldoSpeechBubble>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <div className="w-100">
        <Button
          btnSize="sm"
          btnStyle="link"
          onClick={() =>
            history.push(`/discover/album-folder/${albumFolderId}/no-fr-join`)
          }
        >
          &larr; Back
        </Button>
      </div>
      <>
        <WaldoSpeechBubble position="right" className="mb-4">
          We found multiple matches. Which one is yours?
        </WaldoSpeechBubble>
      </>
      <OnboardingLayoutScrollableContent className="w-100">
        <div className="no-fr-join-choose-identity-container">
          {foundRosterIdentities.map(rosterIdentity => {
            const albumFolderLink = (
              rosterIdentity?.links?.records ?? []
            )?.find(r => r.album_folder?.id === albumFolderId);

            const isSelected = selectedIds.includes(rosterIdentity.id);

            return (
              <div
                key={rosterIdentity.id}
                className="item clickable"
                role="button"
                tabIndex={0}
                aria-disabled={isSelected}
                onClick={() => {
                  if (!isSelected) {
                    onSelectRosterIdentity(rosterIdentity);
                  }
                }}
                onKeyDown={e => {
                  if ((e.key === 'Enter' || e.key === ' ') && !isSelected) {
                    onSelectRosterIdentity(rosterIdentity);
                  }
                }}
              >
                <div className="flex-list-item w-100 px-0">
                  <IdentityAvatarContainer
                    className="mr-2"
                    identity={{
                      ...rosterIdentity,
                      current_photo: rosterIdentity?.selfie_photo,
                    }}
                  />
                  <div className="w-100 d-flex flex-column">
                    <span className="text-dark text-extra-bold">
                      {rosterIdentity.first_name} {rosterIdentity.last_name}
                    </span>
                    {albumFolderLink?.ref_id && (
                      <span className="text-xs text-muted">
                        ID ending in {albumFolderLink?.ref_id.slice(-3)}
                      </span>
                    )}
                  </div>
                  {isSelected && (
                    <span className="ml-auto text-sm text-primary">
                      Selected
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </OnboardingLayoutScrollableContent>
    </Fragment>
  );
};

DiscoverAlbumFolderNoFrJoinChoose.propTypes = propTypes;

export default DiscoverAlbumFolderNoFrJoinChoose;
